export const TaxDocumentStatusValues = ['expected', 'received', 'delivered', 'uploaded'] as const;
export type TaxDocumentStatus = typeof TaxDocumentStatusValues[number];

export const DOWNLOADABLE_TAX_STATUSES: TaxDocumentStatus[] = ['received', 'delivered'];

export const ClientTaxDocumentsOverallStatusValues = ['Awaiting Documents', 'Pending Delivery', 'Ready To File', 'Filed'] as const;
export type ClientTaxDocumentsOverallStatus = typeof ClientTaxDocumentsOverallStatusValues[number];

export const TaxDocumentTypeValues = [
  'NR4',
  'RL1',
  'RL16',
  'RL3',
  'RL32',
  'RRSP_CONTRIBUTION_RECEIPT',
  'T3',
  'T4A',
  'T4FHSA',
  'T4RIF',
  'T4RSP',
  'T5',
  'T5008',
  'TradingSummary',
] as const;
export type TaxDocumentType = typeof TaxDocumentTypeValues[number];

export const TaxDocumentClientTypeValues = ['Contact', 'Legal Entity'] as const;
export type TaxDocumentClientType = typeof TaxDocumentClientTypeValues[number];

export interface ClientTaxDocumentsSummary {
  clientName: string;
  clientQID: string;
  clientType: string;
  status: ClientTaxDocumentsOverallStatus;
  numDocsExpected: number;
  numDocsRecieved: number;
  numDocsDelivered: number;
}

export interface TaxDocument {
  documentId: number,
  document: TaxDocumentType;
  status: TaxDocumentStatus;
  source: string;
  client: string;
  clientQid: string;
  clientType: TaxDocumentClientType;
  receivedDate: string | null;
  deliveredDate: string | null;
  documentName: string;
  taxYear: number;
  s3Filename: string | null;
}

export type ClientQIDToTaxDocumentArrayMap = Record<string, TaxDocument[]>;

//ToDo: this column is the type for the bootstrap table and should probably live elsewhere
export interface TableColumn {
  text: string;
  dataField?: string;
  formatter?: (_cell: any, row: any) => JSX.Element | string | number;
  sort?: boolean;
  editable?: boolean;
  hidden?: boolean;
}

export type TaxDocumentFilters = {
  type?: string;
  status?: string;
  source?: string;
  client?: string;
  account?: string;
};

export interface TaxDocumentDownloadList {
  tax_document_list: TaxDocumentDownloadRequest[];
}

export interface TaxDocumentDownloadRequest {
  s3_url: string;
  document_name: string;
}

export interface TaxDocumentUploadDetails {
  taxDocumentToUpload?: TaxDocument;
}
